import { Metamodel } from '../base/model';
import { Named, Owned } from '../base/named';
import { Folder } from '../folder/folder';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../../model/model-constants';

@Metamodel.model({
    name: ModelConstants.pbiDataflow,
    display: [shellStringResources.DataFlowSingleWord],
    reusable: true,
    referable: true,
    tags: { subType: 'pbidataflow'},
})
export class PbiDataflow extends Named {
    public dataflowId: string;
    public workspaceId: string;
    public name: string;
    public version?: string;
    public isParametric?: boolean;

    // Unused in Trident, but necessary for model service logic
    public folder: Folder = Owned.create(Folder.MODEL, this);

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
